import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { FieldConfig } from '../../../dynamic-form/models/field-config.interface';
import { DynamicFormComponent } from '../../../dynamic-form/dynamic-form.module';
import { ApiService, MetadataService } from '../../../ubi-core/ubi-core.module';
import { environment } from '../../../../environments/environment';
import { Page } from '../../model/page';

const API_URL = environment.apiUrl;

@Component({
  selector: 'ubi-dynamic-list-detail',
  templateUrl: './dynamic-list-detail.component.html',
  styleUrls: ['./dynamic-list-detail.component.scss']
})
export class DynamicListDetailComponent implements OnInit, AfterViewInit {

  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

  @Input()
  entity: string;

  lista: any[];
  selectedItem: any;
  page = new Page();
  protected loading: boolean;

  config: FieldConfig[] = [
    {
      type: 'input',
      label: 'Id',
      name: 'Id',
      placeholder: 'Enter Id',
      disabled: true
    }
  ];

  options = {
    apiUrl: API_URL
  };

  status = {
    canDelete: false,
    canSave: false
  };

  constructor(private baseservice: ApiService, private metadataservice: MetadataService,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal,
    private toastr: ToastrService) {
  }

  ngOnInit() {

    const entityFromRoute = this.route.snapshot.data['entity'];
    const navigateUrlFromRoute = this.route.snapshot.data['navigateUrl'];

    // caso existam os dois o @Input sobrepõe-se ao data do Router
    if (entityFromRoute !== null && entityFromRoute !== undefined
      && (this.entity === null || this.entity === undefined)) {
      this.entity = entityFromRoute;
    }

    this.baseservice.setEntity(this.entity);
    this.metadataservice.setEntity(this.entity);

    this.metadataservice.getMetadataDetail()
      .subscribe(return_value => { this.config = return_value; },
      error => console.log('Error fetching Metadata: ' + error));

    this.page.pageSize = 20;
    this.page.pageNumber = 0;
    this.nextPage();

  }

  ngAfterViewInit() {
    let previousValid = this.form.valid;
    this.form.changes.subscribe(() => {
      if (this.form.valid !== previousValid) {
        previousValid = this.form.valid;
        this.status.canSave = previousValid;
      }
    });

    this.status.canSave = previousValid;
  }

  public search(event) {
    this.baseservice.search(event)
      .subscribe(return_value => this.lista = return_value,
      error => console.log('Error searching: ' + error));
  }

  public selectClick(event, item, clean, content) {

    if (!this.form.pristine) {

      this.modalService.open(content, { backdrop: 'static', keyboard: false }).result.then((result) => {
        if (result === 'Save') {
          this.save();
          this.select(item, clean);
        } else if (result === 'Discard') {
          this.select(item, clean);
        } else {
          // Não faz nada quando se cancela
        }
      });

    } else {
      this.select(item, clean);
    }

  }

  public select(item, clean = false) {
    this.selectedItem = item;
    this.form.setValues(item, clean);
    this.status.canDelete = (this.selectedItem.Id !== undefined);
  }

  public newItem(event, content) {

    if (!this.form.pristine) {

      this.modalService.open(content, { backdrop: 'static', keyboard: false }).result.then((result) => {
        if (result === 'Save') {
          this.save();
          this.select(this.defaultValues(), true);
        } else if (result === 'Discard') {
          this.select(this.defaultValues(), true);
        } else {
          // Não faz nada quando se cancela
        }
      });

    } else {
      this.select(this.defaultValues(), true);
    }

  }

  public defaultValues() {

    const returnValues = {};

    const values = this.config.filter(f => (f.value !== undefined && f.value !== null));
    values.forEach(element => {
      returnValues[element.name] = element.value;
    });

    return returnValues;
  }


  public save() {

    const formModel = this.form.value;
    this.selectedItem = Object.assign(this.selectedItem, formModel);

    this.baseservice.save(this.selectedItem)
      .subscribe(return_value => {
        this.toastr.success('Gravação efectuada com sucesso', '', { timeOut: 3000 });
        if (return_value !== true) {
          this.lista.push(return_value);
          this.select(return_value);
          this.form.clean();
        }
      },
      error => {
        this.toastr.error('Erro na gravação', '', { timeOut: 10000 });
        console.log('Error saving ' + this.entity + ' ' + error);
      });
  }

  public delete(event) {

    if (this.selectedItem.Id !== undefined && this.selectedItem.Id != null) {

      this.baseservice.delete(this.selectedItem)
        .subscribe(return_value => {
          this.lista = this.lista.filter(item => item !== this.selectedItem);
          this.select(this.lista[0]);
        },
        error => console.log('Error deleting ' + this.entity + ' ' + error));
    }
  }

  public onKey(event) {
    console.log(event);
  }

  public nextPage() {

    if (this.loading) {
      return;
    }

    if (this.page.totalPages !== 0 && this.page.pageNumber === +this.page.totalPages) {
      return;
    }

    this.loading = true;
    this.page.pageNumber++;

    this.baseservice.getPage(this.page)
      .subscribe(return_value => {

        if (this.lista === null || this.lista === undefined) {
          this.lista = return_value.data;
        } else {
          return_value.data.forEach(element => {
            this.lista.push(element);
          });
        }

        if (return_value.paging !== undefined && return_value.paging !== null) {
          this.page.totalElements = return_value.paging.totalCount;
          this.page.totalPages = return_value.paging.pageCount;
        }
        this.loading = false;
      },
      error => console.log('Error fetching: ' + error));


  }

  public isSelected(item) {
    return this.selectedItem ?
      this.selectedItem.Id === item.Id : false;
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-entity/components/dynamic-list-detail/dynamic-list-detail.component.ts